// extracted by css-extract-rspack-plugin
var _1 = "text-complete-m_dropdownMenu-TmZRcKSv";
export { _1 as "dropdownMenu" }
